import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import WTinyMce from "@/components/wrappers/w-tiny-mce.vue";
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import WLink from "@/components/wrappers/w-link.vue";
let QuizHtmlEditor = class QuizHtmlEditor extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "editorId", void 0);
    _defineProperty(this, "customEditorConfig", void 0);
    _defineProperty(this, "displayCloseBtn", void 0);
    _defineProperty(this, "closeBtnLabel", void 0);
    _defineProperty(this, "editorTitle", void 0);
    _defineProperty(this, "content", void 0);
    _defineProperty(this, "editorConfig", this.getDefaultEditorConfig());
    _defineProperty(this, "realtimeContent", '');
  }
  mounted() {
    window?.tinymce?.get(this.editorId)?.remove(); // remove eventual old instance. to avoid crash.
    this.editorConfig = {
      ...this.editorConfig,
      ...this.customEditorConfig
    };
  }
  onContentChange() {
    this.realtimeContent = this.content;
  }
  onBlur(content) {
    if (content.trim() !== this.realtimeContent.trim()) {
      this.realtimeContent = content.trim();
      this.$emit('blur', this.realtimeContent);
    }
  }
  onCloseBtnClick() {
    return true;
  }
  getDefaultEditorConfig() {
    return {
      plugins: 'lists advlist code preview link media code codesample',
      toolbar: `undo redo | bold italic underline strikethrough hr | fontfamily blocks forecolor backcolor removeformat | bullist numlist outdent indent align |
                  customimageupload media | link codesample lgit ink code`,
      media_live_embeds: true,
      height: '230px'
    };
  }
};
__decorate([Prop({
  default: 'quiz-html-editor'
})], QuizHtmlEditor.prototype, "editorId", void 0);
__decorate([Prop({
  default: {}
})], QuizHtmlEditor.prototype, "customEditorConfig", void 0);
__decorate([Prop({
  default: false
})], QuizHtmlEditor.prototype, "displayCloseBtn", void 0);
__decorate([Prop({
  default: 'x'
})], QuizHtmlEditor.prototype, "closeBtnLabel", void 0);
__decorate([Prop({
  default: ''
})], QuizHtmlEditor.prototype, "editorTitle", void 0);
__decorate([Prop({
  default: ''
})], QuizHtmlEditor.prototype, "content", void 0);
__decorate([Watch("content")], QuizHtmlEditor.prototype, "onContentChange", null);
__decorate([Emit("closeBtnClick")], QuizHtmlEditor.prototype, "onCloseBtnClick", null);
QuizHtmlEditor = __decorate([Component({
  components: {
    WLink,
    WTinyMce
  },
  emits: ['blur', 'closeBtnClick']
})], QuizHtmlEditor);
export default QuizHtmlEditor;